import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const LandingPage = lazyRouteComponent(() => import('./pages/home'));

export const getRoutes = (): Route[] => [
  {
    page: LandingPage,
    path: ROUTE_PATHS.HOME,
    title: 'NexoTCG',
    hidden: true,
    public: true,
  },
];
